import { Component, computed, Input, OnInit } from '@angular/core';
import { RvsfInitService } from 'src/core/services/common/rvsf-init-service';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styles: ``,
})
export class Footer implements OnInit {
  @Input() type: 'default' | 'dashboard' = 'default';

  rvsfDetails = computed(() => this.rvsfInitService.config()());

  currentYear = new Date().getFullYear();

  constructor(private rvsfInitService: RvsfInitService) {}

  ngOnInit() {}
}
